<template>
  <div class="main-page">
    <section class="page-section">
      <div class="container">
        <div class="grid">
          <div class="col comp-grid">
            <div class="">
              <div>
                <div class="relative-position" style="min-height: 100px">
                  <template v-if="!loading && item">
                    <div class="row q-col-gutter-x-md">
                      <div class="col-12">
                        <div class="mb-2">
                          <div class="grid">
                            <div class="col-12">
                              <div class="text-2xl text-primary">
                                {{ item.firstname }} {{ item.lastname }}
                              </div>
                              <div class="text-sm text-gray-500">
                                {{ item.shs_course }}
                              </div>
                              <Divider />
                            </div>

                            <div class="col-12">
                              <div class="grid">
                                <div class="col-12 md:col-12 mb-2">
                                  <div class="mb-2 font-bold text-sm">
                                    Select Programme *
                                  </div>
                                  <div class="">
                                    <api-data-source @loaded="
                                        (response) =>
                                          mapOptionField(
                                            response,
                                            'programme_choice_id'
                                          )
                                      " api-path="components_data/institution_specific_programme_id_option_list">
                                      <template v-slot="req">
                                        <Dropdown class="w-full" :class="
                                            getErrorClass('programme_choice_id')
                                          " :loading="req.loading" optionLabel="programme_title"
                                          optionValue="institution_programme_id" ref="ctrlprogramme_choice_id" v-model="
                                            myFormData.programme_choice_id
                                          " :options="req.response" :filter="true" label="Select Programme"
                                          placeholder="Select ...">
                                        </Dropdown>
                                      </template>
                                    </api-data-source>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="col-12">
                              <div class="grid">
                                <div class="col-12 md:col-12">
                                  <Button label="Offer Admission" :loading="saving" class="w-full p-button-primary py-3"
                                    @click="offerAdmission" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-if="loading">
                    <div class="p-3 text-center">
                      <ProgressSpinner style="width: 50px; height: 50px" />
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
  import { defineAsyncComponent, ref } from "vue";
  import { PageMixin } from "../../mixins/page.js";
  import { ViewPageMixin } from "../../mixins/viewpage.js";
  import { mapActions, mapGetters, mapState } from "vuex";
  import useVuelidate from "@vuelidate/core";
  import { required } from "@vuelidate/validators";
  export default {
    setup() {
      return { v$: useVuelidate() };
    },
    name: "viewApplicantsPage",
    components: {},
    mixins: [PageMixin, ViewPageMixin],
    props: {
      pageName: {
        type: String,
        default: "applicants",
      },
      idName: {
        type: String,
        default: "applicant_id",
      },
      routeName: {
        type: String,
        default: "applicantsview",
      },
      pagePath: {
        type: String,
        default: "applicants/capsmall_offeradmission",
      },
      apiPath: {
        type: String,
        default: "applicants/offeradmission",
      },
    },
    data() {
      return {
        item: {
          default: {},
        },
        saving: false,
        myFormData: {
          programme_choice_id: "",
        },
      };
    },
    computed: {
      pageTitle: {
        get: function () {
          return "Offer Admission";
        },
      },
      currentRecord: {
        get: function () {
          return this.$store.getters["applicants/currentRecord"];
        },
        set: function (value) {
          this.$store.commit("applicants/setCurrentRecord", value);
        },
      },
    },
    meta() {
      return {
        title: this.pageTitle,
      };
    },
    validations() {
      let myFormData = {
        programme_choice_id: { required },
      };
      return { myFormData };
    },
    methods: {
      ...mapActions("applicants", ["updateRecord", "fetchRecord"]),
      async offerAdmission() {
        const isFormValid = !this.v$.$invalid;
        if (!isFormValid) {
          this.flashMsg("Kindly select programme", "", "error");
          return;
        }
        this.saving = true;
        let id = this.id;
        let url = this.apiUrl;
        let payload = {
          applicant_id: this.item.applicant_id,
          programme_choice_id: this.myFormData.programme_choice_id,
        };
        let data = { id, url, payload };
        this.updateRecord(data).then(
          (response) => {
            this.saving = false;
            this.resetForm();
            this.closeDialogs(); // close page dialog that if opened
            this.flashMsg('Admission offer sent to student');
            this.$EventBus.emit("caps-mall-offer", this.item.applicant_id);
          },
          (response) => {
            this.saving = false;
            this.showPageRequestError(response);
          }
        );
      },
      getErrorClass(field) {
        return {
          "p-invalid": this.v$.myFormData[field].$invalid && this.submitted,
        };
      },
      updateFormFields: function () {
        //update form fields value after load from api
        //e.g convert fieldvalue (value,value2,value2) to array
      },
      resetForm() {
        //reset form fields value
        this.programme_choice_id = "";
      },
    },
    watch: {},
    async mounted() { },
    async created() { },
  };
</script>
<style scoped></style>